// src/lib/scoringEngine.js
import { supabase } from "./supabaseClient";

/**
 * Recompute scores/velocity for given lead ids (server-side RPC).
 * @param {string[]} ids
 */
export async function recomputeScores(ids) {
  if (!ids || ids.length === 0) return { error: null };
  const { error } = await supabase.rpc("recompute_lead_scores", { p_ids: ids });
  return { error };
}

/**
 * Record a behavioral signal for a lead and auto-adjust velocity server-side.
 * @param {string} leadId
 * @param {string} signal  e.g., 'click' | 'reply' | 'dm' | 'like' | 'retweet' | 'visit' | 'open'
 * @param {object} details optional metadata
 */
export async function recordLeadSignal(leadId, signal, details = {}) {
  const { error } = await supabase.rpc("record_lead_activity", {
    p_lead_id: leadId,
    p_signal: signal,
    p_details: details,
  });
  return { error };
}
